import { Body1Stronger, TableCell, TableHeaderCell } from "@fluentui/react-components";
import { useGlobalStatus } from "../../services/GlobalStatusProvider";
import { addDays } from "date-fns";
import TooltipWatcherWidget from '../TooltipWatcherWidget';

export default function Totals({ timesheetData, leaveData }) {
  const { currentWeekStart } = useGlobalStatus();
  const dates = Array.from({ length: 7 }, (_, i) => addDays(currentWeekStart, i));

  // Compute daily totals
  const dailyWorkTotals = dates.map((date) => {
    let totalMinutes = 0;
    timesheetData.forEach((client) => {
      client.projects.forEach((project) => {
        project.budgets.forEach((budget) => {
          budget.timecodes.forEach((timecode) => {
            timecode.entryDays.forEach((entry) => {
              if (entry.date.toString() === date.toString() && entry.status !== "empty" && entry.status !== "error") {
                totalMinutes += entry.entries.reduce((sum, e) => sum + e.totalMinutes, 0);
              }
            });
          });
        });
      });
    });
    return Math.round(totalMinutes / 60 * 100) / 100;
  });

  const leaveTotals = dates.map((date) => {
    let totalHours = 0;
    (leaveData || []).forEach((ld) => {
        if(new Date(ld.date).toDateString() === date.toDateString()){
          totalHours += ld.hours;
        }
    });
    return (totalHours * 100) / 100;
  }); 

  const dailyTotals = dailyWorkTotals.map((dt,index) => dt + leaveTotals[index]); 
  // Compute weekly total
  const weekTotal = dailyTotals.reduce((sum, dayTotal) => sum + dayTotal, 0)

  return (
    <>
    
    <TableHeaderCell style={{fontWeight: "bold" }}>
      <TooltipWatcherWidget text="Total hours for each day across all timecodes and leave" direction="below-start">
      <span>Total</span>
      </TooltipWatcherWidget>
    </TableHeaderCell>
    
      <TableCell style={{backgroundColor: '#eff1f5'}}></TableCell>
    {dailyTotals.map((total, index) => (
        <TableCell style={{backgroundColor: '#F3F3F3'}} key={index}>
          <div className="table-total-cell">
          <Body1Stronger>{total===0? 0 : total.toFixed(2)}hr</Body1Stronger>
          </div>
        </TableCell>
    ))}
    
      <TableCell style={{backgroundColor: '#F3F3F3'}} >
        <TooltipWatcherWidget text="The total hours for the week across all timecodes and leave" direction="below-end">
          <div className="table-total-cell">
            <Body1Stronger style={{fontSize: '16px'}}>{weekTotal===0? 0 : weekTotal.toFixed(2)}hr</Body1Stronger>
          </div>
        </TooltipWatcherWidget>
      </TableCell>
    </>
  );
}
